import styled from 'styled-components';
import FormHelperText from '@material-ui/core/FormHelperText';

export default styled(FormHelperText)`
  line-height: 1.5;
`;



// WEBPACK FOOTER //
// ./src/modules/common/InlineText.js